import type { NotificationResponseDtoTypeEnumKey } from "@dc/gateway-jsonapi";
import { notificationResponseDtoTypeEnum } from "@dc/gateway-jsonapi";
import type { ComponentType } from "react";
import {
  ClipboardCheckLinear,
  ConfettiLinear,
  DangerTriangleLinear,
  DocumentsMinimalisticLinear,
  DocumentTextLinear,
  HashtagCircleLinear,
  type SolarIconProps,
} from "solar-icon-set";

export const NOTIFICATION_CONFIG = {
  [notificationResponseDtoTypeEnum.PRODUCT_UPDATE]: {
    icon: ConfettiLinear,
    iconBg: "bg-bg-container-success-flat",
    iconFg: "text-icon-onSuccessFlat",
  },
  [notificationResponseDtoTypeEnum.TASK]: {
    icon: ClipboardCheckLinear,
    iconBg: "bg-bg-container-punch-flat",
    iconFg: "text-icon-onPunchFlat",
  },
  [notificationResponseDtoTypeEnum.MENTION]: {
    icon: HashtagCircleLinear,
    iconBg: "bg-bg-container-success-flat",
    iconFg: "text-icon-onSuccessFlat",
  },
  [notificationResponseDtoTypeEnum.DOCUMENT]: {
    icon: DocumentTextLinear,
    iconBg: "bg-bg-container-primary-flat",
    iconFg: "text-icon-onPrimaryFlat",
  },
  [notificationResponseDtoTypeEnum.CRUNCH]: {
    icon: DocumentTextLinear,
    iconBg: "bg-bg-container-primary-flat",
    iconFg: "text-icon-onPrimaryFlat",
  },
  [notificationResponseDtoTypeEnum.COMPARISON]: {
    icon: DocumentsMinimalisticLinear,
    iconBg: "bg-bg-container-primary-flat",
    iconFg: "text-icon-onPrimaryFlat",
  },
  [notificationResponseDtoTypeEnum.ERROR]: {
    icon: DocumentTextLinear,
    iconBg: "bg-bg-container-danger-flat",
    iconFg: "text-icon-onDangerFlat",
  },
  [notificationResponseDtoTypeEnum.CHANGE_ORDER]: {
    icon: DangerTriangleLinear,
    iconBg: "bg-bg-container-punch-flat",
    iconFg: "text-icon-onPunchFlat",
  },
} satisfies Record<
  NotificationResponseDtoTypeEnumKey,
  { icon: ComponentType<SolarIconProps>; iconBg: string; iconFg: string }
>;
